import type * as React from 'react'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../table'
import { cn } from '@nwwp/ui-shadcn/lib/utils'

type ComparisonTableColumn = {
  label: React.ReactNode
  /** Visually hide the header (row-label column). */
  srOnly?: boolean
  className?: string
}

type ComparisonTableRow = {
  label: React.ReactNode
  cells: React.ReactNode[]
}

type ComparisonTableProps = {
  columns: ComparisonTableColumn[]
  rows: ComparisonTableRow[]
  className?: string
  cellClassName?: string
}

/** Data-driven comparison table (equity tax / attribute matrices). */
function ComparisonTable({ columns, rows, className, cellClassName }: ComparisonTableProps) {
  const defaultCell = cn('text-left text-body! text-foreground!', cellClassName)

  return (
    <Table className={className} data-slot="comparison-table">
      <TableHeader>
        <TableRow>
          {columns.map((col, i) => (
            <TableHead key={i} className={col.className}>
              {col.srOnly ? <span className="sr-only">{col.label}</span> : col.label}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row, ri) => (
          <TableRow key={ri}>
            <TableCell className={defaultCell}>{row.label}</TableCell>
            {row.cells.map((cell, ci) => (
              <TableCell key={ci} className={defaultCell}>
                {cell}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export { ComparisonTable }
export type { ComparisonTableColumn, ComparisonTableProps, ComparisonTableRow }
